<ng-template #closeButtonRef>
  <img
    src="/assets/svg/ico-hamburger-close.svg"
    class="cross-button pointer-cursor"
    (click)="closeDialog()"
  />
</ng-template>

<div class="modal-main" [formGroup]="formGroup">
  <ng-container *ngIf="stepper === 1">
    <app-user-profile-details
      formGroupName="userDetails"
      [profileDetails]="profileDetails"
      [ownProfile]="ownProfile"
      [sharedData]="sharedData"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(addGroupFlag)]="addGroupFlag"
      (submitToParent)="submitToParent()"
      [groupTypeName]="groupTypeName"
      [userGroupId]="userGroupId"
      [(flowType)]="flowType"
      [userNotHaveExistingGroup]="userNotHaveExistingGroup"
    >
    </app-user-profile-details>
  </ng-container>
  <ng-container *ngIf="stepper === 2">
    <app-user-profile-access
      [profileDetails]="profileDetails"
      userDetailsFormGroupName="userDetails"
      (removeUserAccessHandler)="removeUserAccessHandler($event)"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [ownProfile]="ownProfile"
      accessTimeFormGroupName="shareAccessTime"
      [(selectedAccess)]="selectedAccess"
      [userId]="userId"
      [accessIds]="accessIds"
      [(flowType)]="flowType"
    ></app-user-profile-access>
  </ng-container>
  <ng-container *ngIf="stepper === 3">
    <app-user-profile-groups
      [profileDetails]="profileDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(selectedGroup)]="selectedGroup"
      [(deleteGroupFlag)]="deleteGroupFlag"
      accessTimeFormGroupName="accessTime"
      [ownProfile]="ownProfile"
      [userGroups]="profileDetails.userGroups"
    ></app-user-profile-groups>
  </ng-container>
  <ng-container *ngIf="stepper === 4">
    <app-user-profile-access-time
      formGroupName="accessTime"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [profileDetails]="profileDetails"
      [ownProfile]="ownProfile"
      [userId]="userId"
      [(addGroupFlag)]="addGroupFlag"
      [(deleteGroupFlag)]="deleteGroupFlag"
      (submitToUserProfile)="submitToUserProfile($event)"
      [parentRouteParams]="parentRouteParams"
      [selectedGroup]="selectedGroup"
    >
      <span closeButton>
        <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
      </span>
    </app-user-profile-access-time>
  </ng-container>
  <ng-container *ngIf="stepper === 5">
    <app-user-profile-physical-credentials
      [profileDetails]="profileDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      userDetailsFormGroupName="userDetails"
      [userCredentials]="userCredentials"
    ></app-user-profile-physical-credentials>
  </ng-container>
  <ng-container *ngIf="stepper === 11">
    <app-resend-invitation
      [email]="email"
      [siteId]="sharedData?.selectedSite?.siteId"
      [(stepper)]="stepper"
    ></app-resend-invitation>
  </ng-container>
  <ng-container *ngIf="stepper === 12">
    <app-resend-success
      [SuccessMessage]="'INVITATION_RESENT_SUCCESSFULLY' | translate"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
    ></app-resend-success>
  </ng-container>
  <ng-container *ngIf="stepper === 6">
    <app-user-profile-activity
      [profileDetails]="profileDetails"
      [userActivities]="userActivitiesNew"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(selectedActivity)]="selectedActivity"
      (getMyLastActivity)="getMyLastActivity($event)"
      userDetailsFormGroupName="userDetails"
      ownProfile="ownProfile"
    ></app-user-profile-activity>
  </ng-container>
  <ng-container *ngIf="stepper === 7">
    <div
      class="user-activity d-flex flex-column h-100 w-100 justify-content-center px-4 py-4 modal-main"
    >
      <app-user-profile-group
        class="user-profile-user-group"
        [userStepper]="stepper"
        (userStepperChange)="userStepperChange($event)"
        [userGroup]="userGroup"
        (userGroupChange)="userGroupChange($event)"
        [(selectedGroup)]="selectedGroup"
        formGroupUserDetailName="userDetails"
        [skipStepUserType]="skipStepUserType"
        [skipStepBuilding]="skipStepBuilding"
        [preSelectedGroups]="profileDetails?.userGroups"
        [siteTimeZone]="siteTimeZone"
        [profileDetails]="profileDetails"
        (submitUserGroupToParent)="getUpdatedUserGroups($event)"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
        </span>
      </app-user-profile-group>
    </div>
  </ng-container>

  <ng-container *ngIf="stepper === 8">
    <app-user-profile-access-time-update
      formGroupName="shareAccessTime"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [selectedGroup]="selectedGroup"
      [profileDetails]="profileDetails"
      [ownProfile]="ownProfile"
      [selectedAccess]="selectedAccess"
      (submitToUserProfileEmitter)="submitToUserProfileEmitter($event)"
      [parentRouteParams]="parentRouteParams"
      userDetails="userDetails"
    >
      <span closeButton>
        <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
      </span>
    </app-user-profile-access-time-update>
  </ng-container>

  <ng-container *ngIf="stepper >= 8">
    <app-completed
      [class.d-block]="stepper === 9"
      class="d-none"
      [dialogRef]="dialogRef"
      isAccessComplete="true"
      [(stepper)]="stepper"
      [(flowType)]="flowType"
      (formReset)="formReset()"
    >
    </app-completed>
  </ng-container>

  <ng-container *ngIf="stepper === 10">
    <app-user-profile-groups-without-scheduler
      [profileDetails]="profileDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(selectedGroup)]="selectedGroup"
      [(deleteGroupFlag)]="deleteGroupFlag"
      accessTimeFormGroupName="accessTime"
      [ownProfile]="ownProfile"
      [userGroupList]="userGroupList"
      (userGroupListChange)="userGroupListChange($event)"
    ></app-user-profile-groups-without-scheduler>
  </ng-container>

  <ng-container *ngIf="stepper === 15">
    <app-edit-phone-number
      [(stepper)]="stepper"
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [dialogRef]="dialogRef"
    ></app-edit-phone-number>
  </ng-container>

  <ng-container *ngIf="stepper === 16">
    <app-resend-success
      [SuccessMessage]="'PHONE_UPDATED' | translate"
      [headerTitle]="'USER_PROFILE' | translate"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
    ></app-resend-success>
  </ng-container>

  <ng-container *ngIf="stepper === 13">
    <app-pending-account-deletion
      [autoDeactivationDate]="profileDetails?.autoDeactivationDate"
      [userName]="
        (profileDetails?.firstName || '') +
        ' ' +
        (profileDetails?.lastName || '')
      "
      [(stepper)]="stepper"
      (removeUserAction)="onRemoveUserFromDeletion()"
      (rejectDeletionAction)="onRejectDeletion()"
    ></app-pending-account-deletion>
  </ng-container>

  <ng-container *ngIf="stepper === 14">
    <app-account-reactivated
      [dialogRef]="dialogRef"
      [userName]="
        (profileDetails?.firstName || '') +
        ' ' +
        (profileDetails?.lastName || '')
      "
    ></app-account-reactivated>
  </ng-container>
</div>
